import React, { useEffect } from 'react';
import './VerificationCodeModal.css';

const VerificationCodeModal = ({ validationCode, phoneNumber, verificationMethod, onClose, loading }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="vci-code-modal-overlay">
      <div className="vci-code-modal-content">
        <button type="button" className="vci-code-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="vci-code-modal-header">
          <div className="vci-code-modal-icon">
            <i className="la la-phone"></i>
          </div>
          <h3>Verification Code</h3>
        </div>
        <div className="vci-code-modal-body">
          <p className="vci-code-modal-desc">
            {verificationMethod === 'call'
              ? 'You will receive a phone call shortly. Listen for the following verification code:'
              : 'Use the following verification code sent via SMS:'}
          </p>
          <div className="vci-code-display">
            {validationCode}
          </div>
          <p className="vci-code-modal-phone">
            For phone number: <strong>{phoneNumber}</strong>
          </p>
        </div>
        <div className="vci-code-modal-footer">
          <button className="btn linear-gradient" onClick={onClose} disabled={loading}>
            {loading ? (
              <>
                <span className="vci-code-modal__spinner" />
                Processing...
              </>
            ) : (
              'Done'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationCodeModal;
